import { render, staticRenderFns } from "./checkboxStaffPicked.vue?vue&type=template&id=3932b8b8&scoped=true"
import script from "./checkboxStaffPicked.vue?vue&type=script&lang=js"
export * from "./checkboxStaffPicked.vue?vue&type=script&lang=js"
import style0 from "./checkboxStaffPicked.vue?vue&type=style&index=0&id=3932b8b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3932b8b8",
  null
  
)

export default component.exports